import module from './module.js'

import './components/component.js'
import './components/autorizar/component.js'
import './components/autorizar/proyecto/component.js'
import './components/cotizar/component.js'
import './components/cotizar/proyecto/component.js'
import './components/cotizar/proyecto/nomina/component.js'
import './components/cotizar/proyecto/nomina/aprobar/component.js'
import './components/cotizar/proyecto/nomina/aprobar/dispersion/component.js'
import './components/cotizar/proyecto/nomina/configurando/component.js'
import './components/cotizar/proyecto/nomina/enviar/component.js'
import './components/launcher/component.js'
import './components/layouts/component.js'
import './components/layouts/layout/component.js'
import './components/layouts/layout/nomina/component.js'
import './components/maquilar/component.js'
import './components/maquilar/proyecto/component.js'
import './components/pagar/component.js'
import './components/pagar/proyecto/component.js'
import './components/timbrar/component.js'
import './components/timbrar/proyecto/component.js'
import './routes/nominas.pendientes.autorizar.js'
import './routes/nominas.pendientes.cotizar.js'
import './routes/nominas.pendientes.js'
import './routes/nominas.pendientes.layouts.js'
import './routes/nominas.pendientes.maquilar.js'
import './routes/nominas.pendientes.pagar.js'
import './routes/nominas.pendientes.timbrar.js'

export default module.name



// WEBPACK FOOTER //
// ./src/nominas/pendientes/index.js